module.exports = __webpack_public_path__ + "static/media/wizualizacja-33.d1f96343.png";